import Vue from 'vue'
import Router from 'vue-router'
import { chunkLoadError } from '@engineer/utils'

Vue.use(Router)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const constantRouterMap = [
  {
    path: '/',
    redirect: '/index',
  },
]

const asyncRouterMap = [modules['home-manage']]

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: asyncRouterMap.flat().concat(constantRouterMap),
    mode: 'history',
    base: process.env.VUE_APP_BASE_ROUTE,
  })

const router = createRouter()

/**
 * 懒加载路由组件解析异常时刷新当前页面
 */
router.onError(chunkLoadError(router))

export default router
